export default "__VITE_ASSET__BtsiPSlS__"